export class ProductCardImages extends HTMLElement {
  constructor() {
    super();
    this.dirty = false;
  }

  get container() {
    return this.closest(".product-card__media");
  }

  get prevButton() {
    return this.container?.querySelector("[data-prev-button]");
  }

  get nextButton() {
    return this.container?.querySelector("[data-next-button]");
  }

  connectedCallback() {
    // Avoid unnecessary nesting and DOM queries if there's no content
    if (!this.innerHTML.trim()) {
      if (this.container) this.container.hidden = true;
      return;
    }

    if (!this.classList.contains("flickity")) return;

    this.initCarousel();

    if (!theme.config.isTouch) {
      this.bindHover();
    }
  }

  initCarousel() {
    this.deferSlideImages();

    this.carousel = new Flickity(
      this,
      {
        accessibility: false,
        draggable: true,
        pageDots: true,
        fade: true,
        prevNextButtons: false,
        wrapAround: true,
        setGallerySize: false,
        rightToLeft: theme.config.rtl,
        dragThreshold: 30,
      },
      {
        previous: this.prevButton,
        next: this.nextButton,
      },
    );

    this.carousel.on("select", (index) => {
      this.loadSlideImage(index);
      this.loadSlideImage(index + 1);
    });

    this.bindTouchDirectionGuard();
    this.bindNavigation();
  }

  deferSlideImages() {
    this.querySelectorAll(".media").forEach((slide, i) => {
      if (i <= 1) return;
      const img = slide.querySelector("img");
      if (!img) return;
      const src = img.getAttribute("src");
      const srcset = img.getAttribute("srcset");
      if (src) {
        img.dataset.src = src;
        img.removeAttribute("src");
      }
      if (srcset) {
        img.dataset.srcset = srcset;
        img.removeAttribute("srcset");
      }
    });
  }

  loadSlideImage(index) {
    const slides = this.querySelectorAll(".media");
    const slide = slides[index % slides.length];
    if (!slide) return;
    const img = slide.querySelector("img");
    if (!img || img.getAttribute("src")) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
  }

  bindTouchDirectionGuard() {
    let startX = 0,
      startY = 0,
      scrollDirection = null;

    this.addEventListener(
      "touchstart",
      (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        scrollDirection = null;
      },
      { passive: true },
    );

    this.addEventListener(
      "touchmove",
      (e) => {
        if (scrollDirection === "horizontal") return;

        const dx = Math.abs(e.touches[0].clientX - startX);
        const dy = Math.abs(e.touches[0].clientY - startY);

        if (dx < 5 && dy < 5) return;

        if (scrollDirection === null) {
          scrollDirection = dy > dx ? "vertical" : "horizontal";
        }

        if (scrollDirection === "vertical") {
          e.stopPropagation();
        }
      },
      { capture: true, passive: true },
    );
  }

  bindNavigation() {
    // Only bind if buttons exist
    this.prevButton?.addEventListener("click", () => this.carousel.previous());
    this.nextButton?.addEventListener("click", () => {
      this.dirty = true;
      this.carousel.next();
    });
  }

  bindHover() {
    const productCard = this.container;
    if (!productCard) return;

    productCard.addEventListener("mouseenter", () => this.carousel.select(1));
    productCard.addEventListener("mouseleave", () => {
      if (!this.dirty) this.carousel.select(0);
    });
  }
}

customElements.define("product-card-images", ProductCardImages);
